import { StaticNavigationNavigationItemDtoType } from '@ori/static-api-client-react';

import { createNavigationItemsContext } from './internal';

export const {
  navigationItemsContext: aboutTilesContext,
  NavigationItemsProvider: AboutTilesProvider,
  useNavigationItems: useAboutTiles,
} = createNavigationItemsContext(StaticNavigationNavigationItemDtoType.AboutTiles);
